/**
 * Тарифная модель (мок, дизайн Tariffs). Соло — фикс/мес. Клиника — модель
 * «пакеты»: именованные пакеты по числу платных мест (врачей; админ
 * бесплатно) + гибридная ступень «Сеть» 11+ (базовый = последний пакет +
 * цена за каждое место сверх последней границы).
 *
 * Это единый источник расчёта для калькулятора «Тарифы», модалки «Создать
 * аккаунт» и карточки. Когда подключим BE — константы заменит активная
 * версия из `GET /admin/tariffs` (ADMIN_BACKEND_SPEC §3.6), сигнатура
 * `clinicQuoteFor` не меняется (принимает пакеты параметром).
 */

export const SOLO_PRICE = 1200;

/** Клиника: минимум платных мест (админ бесплатно, сверх — врачи). */
export const CLINIC_MIN_SEATS = 2;

/** Цена за каждое место сверх последней границы пакетов (ступень «Сеть»). */
export const CLINIC_OVER_PRICE = 800;

export type ClinicPackage = {name: string; upTo: number; price: number};

/** Активные пакеты клиники (по возрастанию границы `upTo`). */
export const CLINIC_PACKAGES: readonly ClinicPackage[] = [
  {name: 'Старт', upTo: 3, price: 3000},
  {name: 'Практика', upTo: 6, price: 5000},
  {name: 'Клиника', upTo: 10, price: 8000},
];

export type ClinicQuote = {
  sum: number;
  /** Индекс подходящего пакета (для подсветки активной карточки). */
  pkgIndex: number;
  /** Мест сверх последней границы (>0 → ступень «Сеть»). */
  over: number;
  /** Название пакета или «Сеть» для гибридной ступени. */
  name: string;
  /** Диапазон мест: «4–6 врача» / «11+ врачей». */
  range: string;
  /** Краткий ярлык пакета (для прайс-бара модалки создания). */
  tier: string;
};

/**
 * Сумма/мес и подходящий пакет для числа врачей. Пакеты и цену «сверх»
 * можно передать (живой калькулятор в режиме правки), по умолчанию —
 * активная версия.
 */
export const clinicQuoteFor = (
  seats: number,
  packages: readonly ClinicPackage[] = CLINIC_PACKAGES,
  overPrice: number = CLINIC_OVER_PRICE,
): ClinicQuote => {
  for (let i = 0; i < packages.length; i += 1) {
    const pkg = packages[i];
    if (seats <= pkg.upTo) {
      const lo = i === 0 ? 1 : packages[i - 1].upTo + 1;
      return {
        sum: pkg.price,
        pkgIndex: i,
        over: 0,
        name: pkg.name,
        range: `${lo}–${pkg.upTo} врача`,
        tier: pkg.name,
      };
    }
  }
  const last = packages[packages.length - 1];
  const over = seats - last.upTo;
  return {
    sum: last.price + over * overPrice,
    pkgIndex: packages.length - 1,
    over,
    name: 'Сеть',
    range: `${last.upTo + 1}+ врачей`,
    tier: 'Сеть',
  };
};
